import { render, staticRenderFns } from "./Types of reviews.vue?vue&type=template&id=26005add"
import script from "./Types of reviews.vue?vue&type=script&lang=js"
export * from "./Types of reviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports